export default {
      id: "downloadLogTradingView-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#downloadLogTradingView",
      toString: function () {
        return this.url;
      }
    }